export default __webpack_public_path__ + "static/media/White paper-SC-10.65e9a2b6.pdf";